import type { FC } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { DoubleOptInRedirect as DoubleOptInRedirectUI } from "@jti/ui/components/DoubleOptInRedirect";

import type { doubleOptInRedirectInputs } from "./DoubleOptInRedirect.builder";

export type DoubleOptInRedirectProps = BuilderComponentProps<typeof doubleOptInRedirectInputs>;

export const DoubleOptInRedirect: FC<DoubleOptInRedirectProps> = (props) => {
  return isEditing() ? (
    <div>Double Opt-In Redirect component placeholder</div>
  ) : (
    <DoubleOptInRedirectUI
      successPageRedirectUrl={props.successPageRedirectUrl}
      errorPageRedirectUrl={props.errorPageRedirectUrl}
    />
  );
};
